(function(){
  var host = document.getElementById("nfb-guides");
  if (!host) return;
  var root = host.attachShadow({mode:"open"});
  root.innerHTML = '<link href="https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;600;700&display=swap" rel="stylesheet"><style>\n  .qr{display:flex;flex-wrap:wrap;gap:22px;margin:30px 0 0;padding:22px 0 90px;border-top:1px solid var(--line);}\n  .qr section{flex:1 1 240px;min-width:0;display:flex;flex-direction:column;gap:12px;align-items:flex-start;}\n  .qr img{width:180px;height:180px;flex:0 0 180px;border:1px solid var(--line);border-radius:8px;\n          background:#fff;image-rendering:pixelated;}\n  .qr h4{margin:0 0 5px;font-size:17px;font-weight:600;}\n  .qr p{margin:0;font-size:15px;color:var(--steel);}\n  .qr a{color:var(--ink);}\n  .qr .mailrow{margin-top:7px;}\n  .qr .mail{font-size:16px;font-weight:600;color:var(--ink);text-decoration:none;}\n  .qr .ph{display:inline-block;margin-top:5px;font-size:12px;color:#8A6D00;background:var(--signal-soft);\n          padding:2px 8px;border-radius:999px;}\n\n  :host,body{\n    --ink:#191C1E; --steel:#5B6669; --paper:#EFF2F1; --panel:#FFFFFF;\n    --line:#D2D8D7; --signal:#E8B400; --signal-soft:#FDF3D2; --radius:10px; --max:660px;\n    margin:0; color:#191C1E;\n    font-family:"Archivo",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;\n    font-size:17px; line-height:1.55; -webkit-font-smoothing:antialiased;\n    display:block;\n  }\n  body{background:var(--paper);}\n  *{box-sizing:border-box;}\n  .wrap{max-width:var(--max);margin:0 auto;padding:0 20px;}\n\n  .bar{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:18px 0 26px;\n       border-bottom:1px solid var(--line);}\n  .brand{display:flex;align-items:center;gap:20px;font-weight:600;font-size:36px;\n         letter-spacing:-0.02em;text-decoration:none;color:var(--ink);line-height:1.1;}\n  .barright{display:flex;align-items:center;gap:16px;}\n  .logo{height:130px;width:auto;display:block;}\n  @media (max-width:430px){ .brand{font-size:22px;} .logo{height:88px;} .barright{gap:8px;} }\n  .langs{display:flex;align-items:center;justify-content:flex-end;gap:10px;margin:12px 0 0;}\n  .langs button{font:inherit;font-size:15px;font-weight:500;padding:4px 2px;border:0;background:none;\n                color:var(--steel);cursor:pointer;}\n  .langs button[aria-pressed="true"]{color:var(--ink);font-weight:600;\n                text-decoration:underline;text-underline-offset:5px;text-decoration-thickness:2px;}\n  .langs button:focus-visible{outline:3px solid var(--signal);outline-offset:2px;}\n  .langs .sep{color:var(--line);}\n\n  .finder{padding:34px 0 8px;}\n  h1{font-size:29px;line-height:1.15;letter-spacing:-0.025em;font-weight:700;margin:0 0 8px;}\n  .lede{margin:0 0 22px;color:var(--steel);max-width:44ch;}\n  .search{position:relative;}\n  .search input{width:100%;font:inherit;font-size:18px;padding:15px 15px 15px 46px;\n                border:1.5px solid var(--ink);border-radius:var(--radius);\n                background:var(--panel);color:var(--ink);}\n  .search input:focus{outline:3px solid var(--signal);outline-offset:1px;}\n  .search svg{position:absolute;left:15px;top:50%;transform:translateY(-50%);pointer-events:none;}\n  .crumbs{display:flex;flex-wrap:wrap;align-items:center;gap:9px;margin:20px 0 0;font-size:15px;}\n  .crumbs button{display:inline-flex;align-items:center;justify-content:center;font:inherit;font-size:16px;\n                 font-weight:600;background:var(--panel);border:1.5px solid var(--line);border-radius:999px;\n                 min-height:46px;padding:0 20px;color:var(--ink);cursor:pointer;}\n  .crumbs button:hover{border-color:var(--ink);}\n  .crumbs button:focus-visible{outline:3px solid var(--signal);outline-offset:2px;}\n  .crumbs span{color:var(--steel);}\n  .crumbs b{color:var(--ink);font-weight:600;}\n  .crumbs:empty{display:none;}\n  .cnt{margin-left:auto;font-size:14px;color:var(--steel);white-space:nowrap;padding-left:10px;}\n  .row .cnt + .arrow{margin-left:8px;}\n  .chips{display:flex;flex-wrap:wrap;gap:8px;margin:14px 0 0;}\n  .chips.brands{margin-top:8px;padding-top:10px;border-top:1px solid var(--line);}\n  .chips.brands:empty{display:none;}\n  .chip{font:inherit;font-size:15px;font-weight:500;padding:7px 14px;border:1px solid var(--line);\n        border-radius:999px;background:var(--panel);color:var(--steel);cursor:pointer;}\n  .chip[aria-pressed="true"]{border-color:var(--ink);background:var(--ink);color:#fff;}\n  .chip:focus-visible{outline:3px solid var(--signal);outline-offset:2px;}\n\n  .count{font-size:14px;color:var(--steel);margin:26px 0 10px;}\n  .list{list-style:none;margin:0;padding:0;border-top:1px solid var(--line);}\n  .list li{border-bottom:1px solid var(--line);}\n  .row{display:flex;align-items:center;gap:14px;width:100%;padding:17px 4px;background:transparent;\n       border:0;font:inherit;text-align:left;color:var(--ink);cursor:pointer;}\n  .row:focus-visible{outline:3px solid var(--signal);outline-offset:-3px;}\n  .tag{flex:0 0 44px;height:44px;border-radius:8px;background:var(--paper);border:1px solid var(--line);\n       display:grid;place-items:center;font-weight:700;font-size:13px;color:var(--steel);letter-spacing:0.02em;}\n  .row h2{font-size:16.5px;font-weight:600;margin:0;line-height:1.3;}\n  .row p{margin:2px 0 0;font-size:13.5px;color:var(--steel);line-height:1.35;}\n  .row .arrow{margin-left:auto;flex:0 0 auto;color:var(--steel);}\n  .empty{padding:26px 0;color:var(--steel);}\n\n  .back{display:inline-flex;align-items:center;justify-content:center;gap:9px;font:inherit;font-size:16px;\n        font-weight:600;color:var(--ink);background:var(--panel);border:1.5px solid var(--line);\n        border-radius:999px;min-height:46px;padding:0 20px;margin:18px 0 4px;cursor:pointer;}\n  .back:hover{border-color:var(--ink);}\n  .back:focus-visible{outline:3px solid var(--signal);outline-offset:2px;}\n  .back svg{width:18px;height:18px;}\n  .doc h1{margin-top:12px;}\n  .meta{margin:0 0 20px;font-size:15px;color:var(--steel);}\n  .meta b{color:var(--ink);font-weight:600;}\n  .buy{display:flex;flex-wrap:wrap;gap:10px;margin:0 0 26px;}\n  .btn{display:inline-flex;align-items:center;justify-content:center;gap:9px;\n       min-height:52px;padding:0 22px;border-radius:var(--radius);\n       border:1.5px solid transparent;font-weight:600;font-size:16px;text-decoration:none;\n       flex:1 1 220px;text-align:center;}\n  .btn.primary{background:var(--ink);color:#fff;border-color:var(--ink);}\n  .btn.ghost{background:var(--panel);color:var(--ink);border-color:var(--line);}\n  .btn.ghost:hover{border-color:var(--ink);}\n  .btn:focus-visible{outline:3px solid var(--signal);outline-offset:2px;}\n  .notice{background:var(--signal-soft);border-left:5px solid var(--signal);border-radius:0 8px 8px 0;\n          padding:14px 16px;margin:0 0 26px;font-size:15.5px;}\n  .notice h3{margin:0 0 5px;font-size:15.5px;font-weight:700;}\n  .notice ul{margin:0;padding-left:19px;}\n  .notice li+li{margin-top:3px;}\n  h3.sec{font-size:14px;font-weight:700;margin:30px 0 10px;}\n  .tools{list-style:none;margin:0;padding:0;display:flex;flex-wrap:wrap;gap:7px;}\n  .tools li{font-size:14.5px;background:var(--panel);border:1px solid var(--line);border-radius:6px;padding:5px 10px;}\n  ol.steps{margin:0;padding:0;list-style:none;counter-reset:s;}\n  ol.steps li{counter-increment:s;position:relative;padding:0 0 22px 46px;}\n  ol.steps li::before{content:counter(s);position:absolute;left:0;top:-1px;width:30px;height:30px;\n    border-radius:50%;background:var(--ink);color:#fff;font-size:15px;font-weight:700;display:grid;place-items:center;}\n  ol.steps li::after{content:"";position:absolute;left:14.5px;top:32px;bottom:2px;width:1px;background:var(--line);}\n  ol.steps li:last-child::after{display:none;}\n  ol.steps li:last-child{padding-bottom:6px;}\n  ol.steps strong{display:block;font-weight:600;}\n  ol.steps p{margin:2px 0 0;color:var(--steel);font-size:15.5px;}\n  .videobox{position:relative;width:100%;aspect-ratio:16/9;border-radius:var(--radius);\n            overflow:hidden;background:#000;margin-top:6px;}\n  .videobox iframe,.videobox video{position:absolute;inset:0;width:100%;height:100%;border:0;}\n  .help{margin:34px 0 10px;padding-top:20px;border-top:1px solid var(--line);\n        font-size:14.5px;color:var(--steel);}\n  .help a{color:var(--ink);}\n  .thanks{margin:48px auto 10px;font-size:17px;line-height:1.6;font-weight:500;\n          color:var(--ink);max-width:46ch;text-align:center;}\n  .note{margin:28px 0 0;padding:15px 17px;background:var(--panel);\n        border:1.5px solid var(--ink);border-radius:var(--radius);font-size:16px;line-height:1.5;}\n  .note b{font-weight:600;}\n  .hinweis{margin:0 0 6px;font-size:14.5px;border-left:3px solid var(--signal);padding:2px 0 2px 12px;}\n  ul.plain{margin:0;padding-left:19px;}\n  ul.plain li+li{margin-top:4px;}\n  details.general{border:1px solid var(--line);border-radius:var(--radius);background:var(--panel);\n                  padding:0 16px;margin:0 0 26px;}\n  details.general[open]{padding-bottom:14px;}\n  details.general summary{cursor:pointer;padding:13px 0;font-weight:600;font-size:15.5px;list-style:none;}\n  details.general summary::-webkit-details-marker{display:none;}\n  details.general summary::after{content:"+";float:right;color:var(--steel);font-weight:400;}\n  details.general[open] summary::after{content:"\x813";}\n  details.general summary:focus-visible{outline:3px solid var(--signal);outline-offset:2px;}\n  details.general ul{margin:0;padding-left:19px;font-size:15.5px;color:var(--steel);}\n  details.general li+li{margin-top:5px;}\n  .hide{display:none;}\n  @media (min-width:640px){ :host,body{font-size:18px;} h1{font-size:36px;} }\n</style>' + '\n<div class="wrap">\n  <div class="bar">\n    <a class="brand" href="#" data-home>\n      <span data-t="brand"></span>\n    </a>\n    <img class="logo" src="" alt="Robo Claws">\n  </div>\n\n  <div class="langs" role="group" aria-label="Sprache / Language">\n    <button type="button" data-lang="de" aria-pressed="true">Deutsch</button>\n    <span class="sep">|</span>\n    <button type="button" data-lang="en" aria-pressed="false">English</button>\n  </div>\n\n  <section class="finder" id="finder">\n    <h1 id="title"></h1>\n    <p class="lede" id="lede"></p>\n    <div class="search">\n      <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">\n        <circle cx="11" cy="11" r="7" stroke="#5B6669" stroke-width="2"/>\n        <path d="M16.5 16.5 21 21" stroke="#5B6669" stroke-width="2" stroke-linecap="round"/>\n      </svg>\n      <input id="q" type="search" autocomplete="off" spellcheck="false">\n    </div>\n    <nav class="crumbs" id="crumbs" aria-label="Auswahl"></nav>\n    <p class="count" id="count"></p>\n    <ul class="list" id="list"></ul>\n    <p class="empty hide" id="empty" data-t="empty"></p>\n    <p class="thanks hide" id="thanks"></p>\n  </section>\n\n  <article class="doc hide" id="doc"></article>\n</div>\n';
  var $ = function(s){ return root.querySelector(s); };

const UI = {
  de:{
    brand:"Montageanleitungen", brandOne:"Montageanleitung",
    title:{cat:"Welchen Artikel hast du gekauft?", brand:"Welche Marke hat dein Mähroboter?",
           product:"Welches Modell hast du?", search:"Suchergebnisse"},
    lede:{cat:"Wähle die Produktart – oder such oben direkt nach Marke, Artikelnummer oder EAN.",
          brand:"Der Hersteller steht meist auf dem Gehäuse oder in der App.",
          product:"Tippe auf dein Modell, dann öffnet sich die Anleitung.",
          search:"Alle Anleitungen, die zu deiner Eingabe passen."},
    search:"Marke, Artikelnummer oder EAN …",
    home:"Alle Artikel", clearSearch:"Suche zurücksetzen",
    items:n => n === 1 ? "1 Artikel" : n + " Artikel",
    count:n => n === 1 ? "1 Anleitung" : n + " Anleitungen",
    empty:"Dazu haben wir noch keine Anleitung. Schreib uns kurz, wir schicken sie dir.",
    back:"Zurück", fits:"Passend für:", safety:"Vor dem Start", tools:"Benötigtes Werkzeug", steps:"Montage",
    video:"Montagevideo",
    scope:"Lieferumfang", general:"Allgemeine Sicherheitshinweise",
    after:"Nach der Montage", care:"Pflege und Wartung",
    pdf:"Anleitung als PDF", schablone:"Schablone als PDF", amazon:"Produkt bei Amazon",
    footHelp:"Nichts Passendes gefunden oder ein Teil fehlt? Schreib an support@nf-brothers.de, wir antworten werktags innerhalb eines Tages."
  },
  en:{
    brand:"Assembly guides", brandOne:"Assembly guide",
    title:{cat:"What did you buy?", brand:"Which brand is your mower?",
           product:"Which model do you have?", search:"Search results"},
    lede:{cat:"Pick the type of product – or search above by brand, part number or EAN.",
          brand:"The brand is usually printed on the housing or shown in the app.",
          product:"Tap your model to open the guide.",
          search:"Every guide matching your search."},
    search:"Brand, part number or EAN …",
    home:"All products", clearSearch:"Clear search",
    items:n => n === 1 ? "1 item" : n + " items",
    count:n => n === 1 ? "1 guide" : n + " guides",
    empty:"No guide for that yet. Send us a message and we'll mail it to you.",
    back:"Back", fits:"Fits:", safety:"Before you start", tools:"Tools needed", steps:"Fitting",
    video:"Assembly video",
    scope:"In the box", general:"General safety information",
    after:"After fitting", care:"Care and maintenance",
    pdf:"Download PDF", schablone:"Template PDF", amazon:"View on Amazon",
    footHelp:"Can't find your model or missing a part? Write to support@nf-brothers.de — we reply within one working day."
  }
};

const CATS = {
 "SP": {
  "de": "Spikes",
  "en": "Spikes"
 },
 "KL": {
  "de": "Klingen",
  "en": "Blades"
 },
 "MT": {
  "de": "Messerteller",
  "en": "Blade discs"
 },
 "RS": {
  "de": "Radschutz",
  "en": "Wheel guards"
 },
 "KS": {
  "de": "Kantenschutz",
  "en": "Edge protection"
 },
 "WH": {
  "de": "Wandhalterung",
  "en": "Wall mounts"
 },
 "ZU": {
  "de": "Zubehör",
  "en": "Accessories"
 }
};

/* EBENE 1 - gilt fuer jedes Produkt, erscheint ausklappbar auf jeder Anleitung. */
const GENERAL = {
 "de": [
  "Vor allen Arbeiten den Mähroboter stoppen, ausschalten und stromlos machen: Akku entnehmen oder Sicherheitsschlüssel abziehen.",
  "Warten, bis das Messer vollständig stillsteht.",
  "Arbeitshandschuhe tragen – Klingen und Metallteile sind scharfkantig.",
  "Das Gerät auf eine saubere, weiche Unterlage legen, Display nach unten.",
  "Beschädigte Bauteile nicht montieren. Teile mit Rissen oder ausgeschlagenen Bohrungen ersetzen.",
  "Kinder und Tiere während der Arbeiten fernhalten.",
  "Nach der Montage den Sitz aller Schrauben prüfen, kurz testlaufen lassen und danach noch einmal nachziehen.",
  "Diese Anleitung ergänzt die Bedienungsanleitung deines Mähroboters, sie ersetzt sie nicht. Angaben des Mäherherstellers zu Drehmomenten und zugelassenem Zubehör haben Vorrang."
 ],
 "en": [
  "Before any work, stop the mower, switch it off and cut the power: remove the battery or pull the safety key.",
  "Wait until the blade has come to a complete stop.",
  "Wear work gloves – blades and metal parts have sharp edges.",
  "Rest the unit on a clean, soft surface with the display facing down.",
  "Do not fit damaged parts. Replace components with cracks or worn holes.",
  "Keep children and animals away while you work.",
  "After fitting, check all screws, run a short test and tighten them again afterwards.",
  "This guide adds to your mower's own manual, it does not replace it. The mower manufacturer's specifications on torque and approved accessories take precedence."
 ]
};

/* Hinweis unten auf jeder Anleitung. */
const NOTE = {
 "de": "Fehlt ein Teil oder eine Schraube, oder passt etwas nicht? Melde dich bei uns, bevor du weitermachst – wir schicken dir die fehlenden Teile nach.",
 "en": "Missing a part or a screw, or something does not fit? Get in touch before you carry on – we will send the missing parts."
};

/* Dankestext unten auf der Startseite. */
const THANKS = {
 "de": "Vielen Dank für dein Vertrauen in uns. Hier findest du alle Montageanleitungen zu unseren Produkten. Bei Fragen oder Problemen melde dich einfach bei uns, wir helfen dir weiter.",
 "en": "Thank you for your trust. Here you will find the assembly guides for all our products. If you have any questions or run into trouble, just get in touch and we will help."
};

/* EBENE 2 - Standard je Kategorie. Greift, wenn die Variante nichts eigenes sagt. */
const CATDEF = {
 "SP": {
  "de": {
   "scope": [
    "Satz Spikes (2 Stück)",
    "Schrauben für die Montage"
   ],
   "tools": [
    "Schraubzwingen oder Klemmen",
    "Bohrer 1 bis 1,5 mm (empfohlen)",
    "Schraubendreher",
    "Stift zum Anzeichnen"
   ],
   "safety": [
    "Die Spikes müssen mittig auf dem Reifen sitzen, sonst läuft das Rad unrund.",
    "Vorbohren wird empfohlen, sonst kann der Reifen einreißen.",
    "Schrauben von Hand anziehen und nicht zu fest, sonst zieht sich das Gewinde durch."
   ],
   "steps": [
    {
     "t": "Mäher vorbereiten",
     "d": "Gerät ausschalten, stromlos machen und auf eine weiche Unterlage legen."
    },
    {
     "t": "Seite festlegen",
     "d": "Die Spikes werden je nach Modell innen oder außen auf den Reifen geschraubt."
    },
    {
     "t": "Spikes mittig aufsetzen",
     "d": "Den Spikes-Ring mittig auf den Reifen legen. Die mittige Lage ist entscheidend für einen ruhigen Lauf."
    },
    {
     "t": "Mit Klemmen fixieren",
     "d": "Die Spikes mit Schraubzwingen oder Klemmen festhalten, damit sie beim Anzeichnen nicht verrutschen."
    },
    {
     "t": "Bohrlöcher anzeichnen",
     "d": "Die Positionen der Schraublöcher auf dem Reifen markieren."
    },
    {
     "t": "Vorbohren",
     "d": "Mit einem 1- bis 1,5-mm-Bohrer vorbohren. Empfohlen, damit der Reifen nicht reißt und die Schrauben gerade sitzen."
    },
    {
     "t": "Verschrauben",
     "d": "Die Spikes mit den mitgelieferten Schrauben von Hand befestigen. Nicht zu fest anziehen."
    },
    {
     "t": "Sitz prüfen",
     "d": "Kontrollieren, ob die Spikes mittig sitzen und rundum gleichmäßig anliegen."
    }
   ],
   "after": [
    "Mäher aufrichten und eine Runde fahren lassen.",
    "Nach der ersten vollen Mähfahrt den Sitz noch einmal prüfen."
   ],
   "care": [
    "Nach dem Mähen grobe Grasreste von den Spikes entfernen.",
    "Vor dem Winter gründlich reinigen. Abnehmen ist nicht nötig, die Spikes können dranbleiben.",
    "Verbogene oder stark abgenutzte Spikes ersetzen."
   ]
  },
  "en": {
   "scope": [
    "Set of spikes (2 pieces)",
    "Screws for fitting"
   ],
   "tools": [
    "Clamps",
    "1 to 1.5 mm drill bit (recommended)",
    "Screwdriver",
    "Marker pen"
   ],
   "safety": [
    "The spikes must sit centred on the tyre, otherwise the wheel runs untrue.",
    "Pre-drilling is recommended, otherwise the tyre can tear.",
    "Tighten the screws by hand and not too firmly, or the thread will pull through."
   ],
   "steps": [
    {
     "t": "Prepare the mower",
     "d": "Switch off, cut the power and rest the mower on a soft surface."
    },
    {
     "t": "Choose the side",
     "d": "Depending on the model, the spikes are screwed onto the inside or the outside of the tyre."
    },
    {
     "t": "Centre the spikes",
     "d": "Place the spike ring centred on the tyre. Centring is what keeps the wheel running smoothly."
    },
    {
     "t": "Clamp in place",
     "d": "Hold the spikes with clamps so they cannot slip while you mark the holes."
    },
    {
     "t": "Mark the holes",
     "d": "Mark the screw hole positions on the tyre."
    },
    {
     "t": "Pre-drill",
     "d": "Pre-drill with a 1 to 1.5 mm bit. Recommended so the tyre does not tear and the screws run straight."
    },
    {
     "t": "Screw on",
     "d": "Fit the spikes with the screws supplied, by hand. Do not overtighten."
    },
    {
     "t": "Check the fit",
     "d": "Check that the spikes sit centred and lie evenly all the way round."
    }
   ],
   "after": [
    "Stand the mower up and let it run a lap.",
    "Check the fit once more after the first full mowing run."
   ],
   "care": [
    "Remove coarse grass residue from the spikes after mowing.",
    "Clean them thoroughly before winter. There is no need to take them off, they can stay on.",
    "Replace bent or badly worn spikes."
   ]
  }
 },
 "KL": {
  "de": {
   "scope": [
    "Klingen-Satz",
    "Für jede Klinge eine neue Schraube"
   ],
   "tools": [
    "Schraubendreher passend zu den Klingenschrauben",
    "Arbeitshandschuhe",
    "Behälter für die Altteile"
   ],
   "safety": [
    "Arbeitshandschuhe tragen. Die Klingen sind scharf, es besteht hohe Verletzungsgefahr.",
    "Keinen Akkuschrauber verwenden, weder zum Lösen noch zum Anziehen.",
    "An jeder Position darf nur eine Klinge sitzen, niemals zwei übereinander.",
    "Einmalklingen nicht nachschleifen. Ungleiches Gewicht erzeugt eine Unwucht und beschädigt den Mähroboter.",
    "Immer die neuen Schrauben verwenden. Alte Schrauben brechen leichter."
   ],
   "steps": [
    {
     "t": "Mäher vorbereiten",
     "d": "Gerät ausschalten, stromlos machen und auf den Rücken legen, sodass der Messerteller frei liegt."
    },
    {
     "t": "Alte Klingen abschrauben",
     "d": "Die Klingen vorsichtig lösen und zusammen mit den alten Schrauben entsorgen. Beides wird nicht wiederverwendet."
    },
    {
     "t": "Messerteller reinigen und prüfen",
     "d": "Grasreste entfernen und den Teller auf Risse oder ausgeschlagene Bohrungen kontrollieren. Ein beschädigter Teller gehört ersetzt."
    },
    {
     "t": "Neue Klingen montieren",
     "d": "Je Position eine neue Klinge mit einer neuen Schraube befestigen. Von Hand anziehen, kein Akkuschrauber."
    },
    {
     "t": "Beweglichkeit prüfen",
     "d": "Jede Klinge einmal durchschwenken. Sie muss sich frei um die Schraube drehen lassen und darf nicht klemmen."
    },
    {
     "t": "Auf doppelte Klingen kontrollieren",
     "d": "Alle Positionen einzeln nachzählen. Zwei übereinanderliegende Klingen sind die häufigste Ursache für Unwucht."
    }
   ],
   "after": [
    "Den Mähroboter unter Aufsicht starten und auf das Laufgeräusch achten.",
    "Klingt er lauter als vorher, sofort stoppen. Das deutet auf eine Unwucht hin, meist durch zwei Klingen an einer Position.",
    "Nach dem ersten Mähvorgang alle Schrauben prüfen und nachziehen."
   ],
   "care": [
    "Klingen immer als kompletter Satz wechseln, nie einzeln.",
    "Wechselintervall je nach Nutzung und Rasen: bei normaler Gartenfläche etwa alle 4 bis 8 Wochen.",
    "Früher wechseln bei sandigem Boden, Moos, Ästen oder großer Fläche.",
    "Vor jedem Wechsel auch den Messerteller auf Risse prüfen."
   ]
  },
  "en": {
   "scope": [
    "Set of blades",
    "A new screw for every blade"
   ],
   "tools": [
    "Screwdriver to suit the blade screws",
    "Work gloves",
    "Container for the old parts"
   ],
   "safety": [
    "Wear work gloves. The blades are sharp and the risk of injury is high.",
    "Do not use a power driver, neither to undo nor to tighten.",
    "Only one blade per position, never two stacked on top of each other.",
    "Do not sharpen single-use blades. Uneven weight creates imbalance and damages the mower.",
    "Always use the new screws. Old screws break more easily."
   ],
   "steps": [
    {
     "t": "Prepare the mower",
     "d": "Switch off, cut the power and lay the mower on its back so the blade disc is exposed."
    },
    {
     "t": "Unscrew the old blades",
     "d": "Carefully undo the blades and dispose of them together with the old screws. Neither is reused."
    },
    {
     "t": "Clean and inspect the disc",
     "d": "Remove grass residue and check the disc for cracks or worn holes. Replace a damaged disc."
    },
    {
     "t": "Fit the new blades",
     "d": "One new blade with one new screw per position. Tighten by hand, no power driver."
    },
    {
     "t": "Check free movement",
     "d": "Swing every blade once. It must turn freely around the screw without jamming."
    },
    {
     "t": "Check for double blades",
     "d": "Count every position again. Two stacked blades are the most common cause of imbalance."
    }
   ],
   "after": [
    "Start the mower under supervision and listen to how it runs.",
    "If it sounds louder than before, stop it immediately. That points to imbalance, usually two blades in one position.",
    "Check and retighten all screws after the first mowing run."
   ],
   "care": [
    "Always change the blades as a complete set, never individually.",
    "Change interval depends on use and lawn: roughly every 4 to 8 weeks on a normal garden.",
    "Change sooner with sandy soil, moss, twigs or a large area.",
    "Check the blade disc for cracks at every change."
   ]
  }
 },
 "MT": {
  "de": {
   "scope": [
    "Messerteller",
    "Schrauben mit Sicherungslack (bereits aufgetragen)",
    "Neue Klingen"
   ],
   "tools": [
    "Schraubendreher passend zu den Schrauben",
    "Arbeitshandschuhe",
    "Behälter für die Altteile"
   ],
   "safety": [
    "Arbeitshandschuhe tragen. Die Klingen sind scharf, es besteht hohe Verletzungsgefahr.",
    "Keinen Akkuschrauber verwenden, weder zum Lösen noch zum Anziehen.",
    "Nur die mitgelieferten Schrauben verwenden. Der Sicherungslack ist bereits aufgetragen und wirkt nur beim ersten Anziehen.",
    "Den neuen Messerteller nur mit neuen Klingen in Betrieb nehmen, keine gebrauchten wieder aufsetzen."
   ],
   "steps": [
    {
     "t": "Mäher vorbereiten",
     "d": "Gerät ausschalten, stromlos machen und auf den Rücken legen, sodass der Messerteller frei liegt."
    },
    {
     "t": "Klingen abnehmen",
     "d": "Die vorhandenen Klingen abschrauben und zusammen mit ihren Schrauben entsorgen."
    },
    {
     "t": "Alten Messerteller demontieren",
     "d": "Den alten Teller lösen und abnehmen."
    },
    {
     "t": "Aufnahme reinigen",
     "d": "Aufgewickeltes Gras und Erde von der Motorwelle entfernen, damit der neue Teller spielfrei sitzt."
    },
    {
     "t": "Neuen Messerteller montieren",
     "d": "Den neuen Teller auflegen und mit den mitgelieferten Schrauben von Hand befestigen. Nicht zu fest anziehen."
    },
    {
     "t": "Probelauf ohne Klingen",
     "d": "Den Mäher ohne montierte Klingen kurz laufen lassen. Läuft er ruhig und leise, sitzt der Teller richtig. Bei Geräuschen sofort stoppen und den Sitz prüfen."
    },
    {
     "t": "Klingen montieren",
     "d": "Erst danach die mitgelieferten neuen Klingen anbringen, je Position eine Klinge mit einer neuen Schraube."
    },
    {
     "t": "Sitz prüfen",
     "d": "Alle Schrauben und die Beweglichkeit der Klingen noch einmal kontrollieren."
    }
   ],
   "after": [
    "Nach der Montage alle Schrauben erneut prüfen.",
    "Nach dem ersten Mähvorgang die Schrauben nachziehen."
   ],
   "care": [
    "Den Messerteller regelmäßig auf Risse, ausgeschlagene Bohrungen und andere Beschädigungen kontrollieren.",
    "Der Messerteller ist ein stark beanspruchtes Verschleißteil. Wir empfehlen, ihn jedes Jahr zu ersetzen.",
    "Ein rechtzeitiger Wechsel verhindert größere Schäden am Mähroboter."
   ]
  },
  "en": {
   "scope": [
    "Blade disc",
    "Screws with thread locker (already applied)",
    "New blades"
   ],
   "tools": [
    "Screwdriver to suit the screws",
    "Work gloves",
    "Container for the old parts"
   ],
   "safety": [
    "Wear work gloves. The blades are sharp and the risk of injury is high.",
    "Do not use a power driver, neither to undo nor to tighten.",
    "Use only the screws supplied. The thread locker is already applied and only works on first tightening.",
    "Run the new disc with new blades only, never refit used ones."
   ],
   "steps": [
    {
     "t": "Prepare the mower",
     "d": "Switch off, cut the power and lay the mower on its back so the blade disc is exposed."
    },
    {
     "t": "Remove the blades",
     "d": "Unscrew the existing blades and dispose of them together with their screws."
    },
    {
     "t": "Remove the old disc",
     "d": "Undo the old disc and take it off."
    },
    {
     "t": "Clean the mount",
     "d": "Remove wrapped grass and soil from the motor shaft so the new disc seats without play."
    },
    {
     "t": "Fit the new disc",
     "d": "Place the new disc on and fit the screws supplied by hand. Do not overtighten."
    },
    {
     "t": "Test run without blades",
     "d": "Run the mower briefly with no blades fitted. If it runs smoothly and quietly, the disc is seated correctly. Stop at once if you hear anything."
    },
    {
     "t": "Fit the blades",
     "d": "Only then attach the new blades supplied, one blade with one new screw per position."
    },
    {
     "t": "Check the fit",
     "d": "Check all screws again and make sure the blades swing freely."
    }
   ],
   "after": [
    "Check all screws again after fitting.",
    "Retighten the screws after the first mowing run."
   ],
   "care": [
    "Check the disc regularly for cracks, worn holes and other damage.",
    "The blade disc is a heavily loaded wear part. We recommend replacing it every year.",
    "Replacing it in good time prevents bigger damage to the mower."
   ]
  }
 },
 "RS": {
  "de": {
   "scope": [
    "Radschutz"
   ],
   "tools": [
    "Kein Werkzeug nötig",
    "Schüssel mit warmem Wasser (empfohlen)"
   ],
   "safety": [
    "Mäher ausschalten und stromlos machen, bevor du an den Rädern arbeitest.",
    "Das Wasser darf höchstens 50 °C haben. Heißer verformt den Kunststoff dauerhaft.",
    "Nach der Montage muss sich das Rad frei drehen lassen."
   ],
   "steps": [
    {
     "t": "Mäher vorbereiten",
     "d": "Gerät ausschalten, stromlos machen und seitlich auf eine weiche Unterlage legen."
    },
    {
     "t": "Radschutz anwärmen",
     "d": "Empfohlen: den Radschutz vor der Montage fünf Minuten in etwa 50 °C warmes Wasser legen. Der Kunststoff wird kurzzeitig weicher und lässt sich deutlich leichter überstülpen."
    },
    {
     "t": "Über den Reifen stülpen",
     "d": "Den Radschutz über den Reifen des Mähroboters ziehen."
    },
    {
     "t": "Aufdrehen",
     "d": "Den Radschutz kräftig auf den Reifen drehen, bis er rundum fest sitzt."
    },
    {
     "t": "Zentrieren",
     "d": "Durch leichtes Drücken ausrichten, bis der Radschutz mittig auf dem Reifen sitzt."
    },
    {
     "t": "Freilauf prüfen",
     "d": "Das Rad von Hand drehen. Es muss frei laufen und darf nirgends schleifen."
    }
   ],
   "after": [
    "Am Radschutz ziehen, er darf sich nicht abziehen lassen.",
    "Nach der ersten Mähfahrt den Sitz noch einmal prüfen."
   ],
   "care": [
    "Grasreste und Erde nach dem Mähen entfernen.",
    "Regelmäßig auf Risse und Verschleiß kontrollieren und bei Beschädigung ersetzen."
   ]
  },
  "en": {
   "scope": [
    "Wheel guard"
   ],
   "tools": [
    "No tools needed",
    "Bowl of warm water (recommended)"
   ],
   "safety": [
    "Switch the mower off and cut the power before working on the wheels.",
    "The water must not exceed 50 °C. Hotter water deforms the plastic permanently.",
    "The wheel must turn freely once the guard is fitted."
   ],
   "steps": [
    {
     "t": "Prepare the mower",
     "d": "Switch off, cut the power and rest the mower on its side on a soft surface."
    },
    {
     "t": "Warm the guard",
     "d": "Recommended: put the guard in water of about 50 °C for five minutes. The plastic softens briefly and slips on far more easily."
    },
    {
     "t": "Slip it over the tyre",
     "d": "Pull the guard over the tyre of the mower."
    },
    {
     "t": "Twist it on",
     "d": "Twist the guard firmly onto the tyre until it holds all the way round."
    },
    {
     "t": "Centre it",
     "d": "Press gently to align it until the guard sits centred on the tyre."
    },
    {
     "t": "Check free rotation",
     "d": "Turn the wheel by hand. It must run freely without rubbing."
    }
   ],
   "after": [
    "Pull on the guard, it must not come off.",
    "Check the fit again after the first mowing run."
   ],
   "care": [
    "Remove grass and soil after mowing.",
    "Check regularly for cracks and wear, replace the guard if damaged."
   ]
  }
 },
 "KS": {
  "de": {
   "scope": [
    "Kantenschutz mit Klebestreifen"
   ],
   "tools": [
    "Reinigungstuch",
    "Reinigungsalkohol oder Isopropanol (empfohlen)"
   ],
   "safety": [
    "Die Klebefläche muss sauber, fett- und staubfrei und vollständig trocken sein. Sonst hält der Klebestreifen nicht.",
    "Die Position vor dem Abziehen des Schutzpapiers prüfen. Der Klebestreifen haftet nur einmal richtig.",
    "Bei kaltem Wetter hält der Kleber schlechter. Verklebe möglichst bei mindestens 15 °C."
   ],
   "steps": [
    {
     "t": "Mäher vorbereiten",
     "d": "Gerät ausschalten und stromlos machen."
    },
    {
     "t": "Klebefläche reinigen",
     "d": "Die Stelle am Gehäuse gründlich säubern. Sie muss fettfrei und staubfrei sein, am besten mit Reinigungsalkohol abwischen und vollständig trocknen lassen."
    },
    {
     "t": "Position prüfen",
     "d": "Den Kantenschutz trocken anlegen und die Lage kontrollieren, solange das Schutzpapier noch drauf ist."
    },
    {
     "t": "Schutzpapier abziehen",
     "d": "Das Papier vom Klebestreifen abziehen, ohne die Klebefläche mit den Fingern zu berühren."
    },
    {
     "t": "Anlegen und festdrücken",
     "d": "Den Kantenschutz anlegen und kräftig festdrücken, von der Mitte nach außen arbeiten."
    }
   ],
   "after": [
    "Die gesamte Länge noch einmal kräftig nachdrücken.",
    "Vor der ersten Mähfahrt einige Stunden stehen lassen, damit der Kleber fest anzieht."
   ],
   "care": [
    "Bei Verschmutzung mit einem feuchten Tuch reinigen.",
    "Von Zeit zu Zeit prüfen, ob der Kantenschutz noch überall fest anliegt."
   ]
  },
  "en": {
   "scope": [
    "Edge protection with adhesive strip"
   ],
   "tools": [
    "Cleaning cloth",
    "Rubbing alcohol or isopropanol (recommended)"
   ],
   "safety": [
    "The bonding surface must be clean, free of grease and dust and completely dry, otherwise the strip will not hold.",
    "Check the position before you peel off the backing paper. The adhesive only bonds properly once.",
    "The adhesive holds less well in cold weather. Apply at 15 °C or above if you can."
   ],
   "steps": [
    {
     "t": "Prepare the mower",
     "d": "Switch the mower off and cut the power."
    },
    {
     "t": "Clean the surface",
     "d": "Clean the spot on the housing thoroughly. It must be free of grease and dust, ideally wiped with alcohol and left to dry."
    },
    {
     "t": "Check the position",
     "d": "Hold the edge protection in place dry and check the alignment while the backing paper is still on."
    },
    {
     "t": "Peel the backing",
     "d": "Pull the paper off the adhesive strip without touching the adhesive with your fingers."
    },
    {
     "t": "Apply and press firmly",
     "d": "Put the edge protection in place and press hard, working from the centre outwards."
    }
   ],
   "after": [
    "Press along the whole length once more.",
    "Leave it for a few hours before the first mowing run so the adhesive can set."
   ],
   "care": [
    "Clean with a damp cloth when dirty.",
    "Check now and then that the edge protection still sits tight everywhere."
   ]
  }
 },
 "WH": {
  "de": {
   "scope": [
    "Wandhalterungen",
    "Schrauben und Dübel",
    "Papierschablone zum Ausdrucken"
   ],
   "tools": [
    "Bohrmaschine",
    "6-mm-Bohrer",
    "Wasserwaage",
    "Stift",
    "Schraubendreher",
    "Leitungssuchgerät",
    "Drucker für die Schablone"
   ],
   "safety": [
    "Wichtig: Die ausgedruckte Schablone vor dem Bohren nachmessen. Die eingezeichnete Strecke muss genau 175 mm lang sein. Stimmt das Maß nicht, hat dein Drucker die Vorlage skaliert und die Bohrlöcher sitzen falsch.",
    "Vor dem Bohren die Wand auf Strom- und Wasserleitungen prüfen.",
    "Die beiliegenden Dübel passen für Beton und Ziegel. Für Gipskarton oder Hohlwände brauchst du passende Spezialdübel aus dem Baumarkt.",
    "Die Halterung muss das Gewicht des Mähroboters dauerhaft tragen."
   ],
   "steps": [
    {
     "t": "Schablone ausdrucken und nachmessen",
     "d": "Die Papierschablone lädst du über den Knopf \"Schablone als PDF\" herunter. In Originalgröße ausdrucken, ohne Anpassung an die Seitengröße. Danach mit Lineal oder Zollstock nachmessen: die eingezeichnete Strecke muss genau 175 mm ergeben."
    },
    {
     "t": "Position wählen",
     "d": "Einen Platz wählen, an dem der Mäher gut erreichbar ist und die Ladestation frei bleibt."
    },
    {
     "t": "Anzeichnen",
     "d": "Die Schablone an die Wand halten, mit der Wasserwaage ausrichten und die Bohrpunkte an den Kreuzmarken mit einem Stift übertragen."
    },
    {
     "t": "Leitungen prüfen",
     "d": "Die angezeichneten Stellen mit dem Leitungssuchgerät kontrollieren, bevor du bohrst."
    },
    {
     "t": "Bohren",
     "d": "Erst bohren, wenn die Schablone nachgemessen und das Maß bestätigt ist. Dann mit einem 6-mm-Bohrer 40 mm tief bohren."
    },
    {
     "t": "Dübel setzen",
     "d": "Die beiliegenden Dübel bündig in die Bohrlöcher einsetzen."
    },
    {
     "t": "Halterungen anschrauben",
     "d": "Die Halterungen ansetzen und mit den beiliegenden Schrauben festschrauben."
    },
    {
     "t": "Belastung testen",
     "d": "Mit der Hand kräftig nach unten ziehen. Erst wenn nichts nachgibt, den Mäher einhängen."
    }
   ],
   "after": [
    "Den Mäher einhängen und prüfen, ob er sicher und waagerecht hängt.",
    "Nach einigen Wochen den festen Sitz der Schrauben noch einmal kontrollieren."
   ],
   "care": [
    "Die Schrauben gelegentlich auf festen Sitz prüfen.",
    "Bei Rissen im Putz oder lockerer Halterung die Befestigung erneuern."
   ]
  },
  "en": {
   "scope": [
    "Wall brackets",
    "Screws and wall plugs",
    "Paper template for printing"
   ],
   "tools": [
    "Drill",
    "6 mm drill bit",
    "Spirit level",
    "Pencil",
    "Screwdriver",
    "Cable detector",
    "Printer for the template"
   ],
   "safety": [
    "Important: measure the printed template before you drill. The marked distance must be exactly 175 mm. If it is not, your printer scaled the template and the holes will be in the wrong place.",
    "Check the wall for electrical cables and pipes before drilling.",
    "The plugs supplied are for concrete and brick. Plasterboard or hollow walls need special plugs from a hardware store.",
    "The bracket has to carry the weight of the mower permanently."
   ],
   "steps": [
    {
     "t": "Print and measure the template",
     "d": "Download the paper template with the \"Template PDF\" button. Print it at original size, with no fit-to-page. Then measure it: the marked distance must come out at exactly 175 mm."
    },
    {
     "t": "Choose the position",
     "d": "Pick a spot where the mower is easy to reach and the charging station stays clear."
    },
    {
     "t": "Mark the holes",
     "d": "Hold the template against the wall, level it and transfer the drill points at the cross marks with a pencil."
    },
    {
     "t": "Check for cables",
     "d": "Scan the marked spots with the cable detector before drilling."
    },
    {
     "t": "Drill",
     "d": "Only drill once you have measured the template and confirmed the dimension. Then drill 40 mm deep with a 6 mm bit."
    },
    {
     "t": "Insert the plugs",
     "d": "Push the supplied wall plugs flush into the holes."
    },
    {
     "t": "Screw on the brackets",
     "d": "Position the brackets and fix them with the screws supplied."
    },
    {
     "t": "Load test",
     "d": "Pull down hard by hand. Only hang the mower up once nothing gives."
    }
   ],
   "after": [
    "Hang the mower up and check that it sits securely and level.",
    "Check the screws again after a few weeks."
   ],
   "care": [
    "Check the screws for tightness from time to time.",
    "Renew the fixing if the plaster cracks or the bracket works loose."
   ]
  }
 },
 "ZU": {
  "de": {
   "tools": [
    "—"
   ],
   "safety": [],
   "steps": [
    {
     "t": "Zubehör montieren",
     "d": "Text folgt."
    }
   ],
   "after": [],
   "care": [],
   "scope": []
  },
  "en": {
   "tools": [
    "—"
   ],
   "safety": [],
   "steps": [
    {
     "t": "Fitting the accessory",
     "d": "Text to follow."
    }
   ],
   "after": [],
   "care": [],
   "scope": []
  }
 }
};

/* EBENE 3 - Montagevarianten. Schluessel steht beim Produkt unter "variant".
   Nur abweichende Felder eintragen (tools, safety, steps, after, care, scope). */
const VARIANTS = {
 "SP-AUSSEN": {
  "de": {
   "tools": [
    "Schraubzwingen oder Klemmen",
    "Bohrer 1 bis 1,5 mm (empfohlen)",
    "Schraubendreher",
    "Stift zum Anzeichnen"
   ],
   "safety": [
    "Die Spikes müssen mittig auf dem Rad sitzen, sonst läuft das Rad unrund.",
    "Vorbohren wird empfohlen, sonst kann der Reifen einreißen.",
    "Schrauben von Hand anziehen und nicht zu fest, sonst zieht sich das Gewinde durch."
   ],
   "steps": [
    {
     "t": "Mäher vorbereiten",
     "d": "Gerät ausschalten, stromlos machen und auf eine weiche Unterlage legen."
    },
    {
     "t": "Spikes mittig auflegen",
     "d": "Den Spikes-Satz von außen mittig auf das Rad legen. Die mittige Lage entscheidet über den ruhigen Lauf."
    },
    {
     "t": "Mit Klemmen fixieren",
     "d": "Die Spikes mit Schraubzwingen oder Klemmen festhalten, damit sie beim Anzeichnen nicht verrutschen."
    },
    {
     "t": "Bohrlöcher anzeichnen",
     "d": "Die Positionen der Schraublöcher auf dem Rad markieren."
    },
    {
     "t": "Vorbohren",
     "d": "Mit einem 1- bis 1,5-mm-Bohrer vorbohren. Empfohlen, damit der Reifen nicht reißt und die Schrauben gerade sitzen."
    },
    {
     "t": "Verschrauben",
     "d": "Die Spikes mit den mitgelieferten Schrauben von Hand befestigen. Nicht zu fest anziehen."
    },
    {
     "t": "Sitz prüfen",
     "d": "Kontrollieren, ob die Spikes mittig sitzen und rundum gleichmäßig anliegen."
    }
   ]
  },
  "en": {
   "tools": [
    "Clamps",
    "1 to 1.5 mm drill bit (recommended)",
    "Screwdriver",
    "Marker pen"
   ],
   "safety": [
    "The spikes must sit centred on the wheel, otherwise it runs untrue.",
    "Pre-drilling is recommended, otherwise the tyre can tear.",
    "Tighten the screws by hand and not too firmly, or the thread will pull through."
   ],
   "steps": [
    {
     "t": "Prepare the mower",
     "d": "Switch off, cut the power and rest the mower on a soft surface."
    },
    {
     "t": "Place the spikes",
     "d": "Lay the spike set centred on the outside of the wheel. Centring is what keeps it running smoothly."
    },
    {
     "t": "Clamp in place",
     "d": "Hold the spikes with clamps so they cannot slip while you mark the holes."
    },
    {
     "t": "Mark the holes",
     "d": "Mark the screw hole positions on the wheel."
    },
    {
     "t": "Pre-drill",
     "d": "Pre-drill with a 1 to 1.5 mm bit so the tyre does not tear and the screws run straight."
    },
    {
     "t": "Screw on",
     "d": "Fit the spikes with the screws supplied, by hand. Do not overtighten."
    },
    {
     "t": "Check the fit",
     "d": "Check that the spikes sit centred and lie evenly all the way round."
    }
   ]
  }
 },
 "SP-INNEN": {
  "de": {
   "tools": [
    "Werkzeug für den Radausbau (je nach Modell)",
    "Schraubzwingen oder Klemmen",
    "Bohrer 1 bis 1,5 mm (empfohlen)",
    "Schraubendreher",
    "Stift zum Anzeichnen"
   ],
   "safety": [
    "Die Spikes werden auf der Innenseite montiert, dafür muss das Rad ab.",
    "Die Spikes müssen mittig sitzen, sonst läuft das Rad unrund.",
    "Vorbohren wird empfohlen, sonst kann der Reifen einreißen.",
    "Schrauben von Hand anziehen und nicht zu fest."
   ],
   "steps": [
    {
     "t": "Mäher vorbereiten",
     "d": "Gerät ausschalten, stromlos machen und auf eine weiche Unterlage legen."
    },
    {
     "t": "Rad abnehmen",
     "d": "Das Rad abschrauben und von der Antriebsachse ziehen. Schrauben aufbewahren."
    },
    {
     "t": "Spikes mittig auflegen",
     "d": "Den Spikes-Satz von innen mittig auf das Rad legen."
    },
    {
     "t": "Mit Klemmen fixieren",
     "d": "Die Spikes festklemmen, damit sie beim Anzeichnen nicht verrutschen."
    },
    {
     "t": "Anzeichnen und vorbohren",
     "d": "Bohrlöcher markieren und mit einem 1- bis 1,5-mm-Bohrer vorbohren."
    },
    {
     "t": "Verschrauben",
     "d": "Die Spikes mit den mitgelieferten Schrauben von Hand befestigen. Nicht zu fest anziehen."
    },
    {
     "t": "Rad wieder montieren",
     "d": "Das Rad zurück auf die Achse setzen und wieder festschrauben."
    },
    {
     "t": "Freilauf prüfen",
     "d": "Das Rad von Hand drehen. Es muss frei laufen und darf nirgends schleifen."
    }
   ]
  },
  "en": {
   "tools": [
    "Tool to remove the wheel (model dependent)",
    "Clamps",
    "1 to 1.5 mm drill bit (recommended)",
    "Screwdriver",
    "Marker pen"
   ],
   "safety": [
    "The spikes go on the inside, so the wheel has to come off.",
    "The spikes must sit centred, otherwise the wheel runs untrue.",
    "Pre-drilling is recommended, otherwise the tyre can tear.",
    "Tighten the screws by hand and not too firmly."
   ],
   "steps": [
    {
     "t": "Prepare the mower",
     "d": "Switch off, cut the power and rest the mower on a soft surface."
    },
    {
     "t": "Remove the wheel",
     "d": "Unscrew the wheel and pull it off the drive axle. Keep the screws."
    },
    {
     "t": "Place the spikes",
     "d": "Lay the spike set centred on the inside of the wheel."
    },
    {
     "t": "Clamp in place",
     "d": "Clamp the spikes so they cannot slip while you mark the holes."
    },
    {
     "t": "Mark and pre-drill",
     "d": "Mark the holes and pre-drill with a 1 to 1.5 mm bit."
    },
    {
     "t": "Screw on",
     "d": "Fit the spikes with the screws supplied, by hand. Do not overtighten."
    },
    {
     "t": "Refit the wheel",
     "d": "Put the wheel back on the axle and screw it down again."
    },
    {
     "t": "Check free rotation",
     "d": "Turn the wheel by hand. It must run freely without rubbing."
    }
   ]
  }
 },
 "SP-SENKKOPF": {
  "de": {
   "scope": [
    "Satz Spikes (2 Stück)",
    "Senkkopfschrauben für die Montage"
   ],
   "tools": [
    "Schraubendreher passend zu den vorhandenen Radschrauben"
   ],
   "safety": [
    "Die sechs Originalschrauben aufbewahren, du brauchst sie für den Rückbau.",
    "Nur die mitgelieferten Senkkopfschrauben verwenden, sie sitzen bündig im Spike.",
    "Schrauben von Hand anziehen und nicht zu fest."
   ],
   "steps": [
    {
     "t": "Mäher vorbereiten",
     "d": "Gerät ausschalten, stromlos machen und auf eine weiche Unterlage legen."
    },
    {
     "t": "Radschrauben entfernen",
     "d": "Die sechs vorhandenen Schrauben aus dem Rad herausdrehen und beiseitelegen."
    },
    {
     "t": "Spikes aufsetzen",
     "d": "Den Spikes-Satz auf das Rad setzen und die Bohrungen mit den Gewinden im Rad zur Deckung bringen."
    },
    {
     "t": "Verschrauben",
     "d": "Mit den mitgelieferten Senkkopfschrauben über Kreuz von Hand befestigen. Nicht zu fest anziehen."
    },
    {
     "t": "Sitz prüfen",
     "d": "Kontrollieren, ob die Spikes rundum gleichmäßig anliegen und das Rad frei läuft."
    }
   ]
  },
  "en": {
   "scope": [
    "Set of spikes (2 pieces)",
    "Countersunk screws for fitting"
   ],
   "tools": [
    "Screwdriver to suit the existing wheel screws"
   ],
   "safety": [
    "Keep the six original screws, you will need them to revert.",
    "Use only the countersunk screws supplied, they sit flush in the spike.",
    "Tighten the screws by hand and not too firmly."
   ],
   "steps": [
    {
     "t": "Prepare the mower",
     "d": "Switch off, cut the power and rest the mower on a soft surface."
    },
    {
     "t": "Remove the wheel screws",
     "d": "Undo the six existing screws in the wheel and set them aside."
    },
    {
     "t": "Position the spikes",
     "d": "Place the spike set on the wheel and line the holes up with the threads in the wheel."
    },
    {
     "t": "Screw on",
     "d": "Fit the countersunk screws supplied, crosswise and by hand. Do not overtighten."
    },
    {
     "t": "Check the fit",
     "d": "Check that the spikes lie evenly all round and the wheel turns freely."
    }
   ]
  }
 },
 "SP-KAPPE": {
  "de": {
   "scope": [
    "Satz Spikes (2 Stück)",
    "Kunststoff-Distanzteile",
    "Gewindeschrauben für die Montage"
   ],
   "tools": [
    "Schlitzschraubendreher",
    "Schraubendreher für die Gewindeschrauben"
   ],
   "safety": [
    "Die Radkappe vorsichtig lösen, damit die Rastnasen nicht brechen.",
    "Ohne die Kunststoff-Distanzteile sitzen die Spikes nicht richtig.",
    "Schrauben von Hand anziehen und nicht zu fest."
   ],
   "steps": [
    {
     "t": "Mäher vorbereiten",
     "d": "Gerät ausschalten, stromlos machen und auf eine weiche Unterlage legen."
    },
    {
     "t": "Radkappe abnehmen",
     "d": "Die Radkappe mit einem Schlitzschraubendreher vorsichtig heraushebeln."
    },
    {
     "t": "Distanzteile einsetzen",
     "d": "Die Kunststoff-Distanzteile an den dafür vorgesehenen Stellen einlegen."
    },
    {
     "t": "Spikes auflegen",
     "d": "Den Spikes-Satz auflegen und die Bohrungen mit den Distanzteilen zur Deckung bringen."
    },
    {
     "t": "Verschrauben",
     "d": "Mit den mitgelieferten Gewindeschrauben von Hand verschrauben. Nicht zu fest anziehen."
    },
    {
     "t": "Sitz prüfen",
     "d": "Kontrollieren, ob alles gleichmäßig anliegt und das Rad frei läuft."
    }
   ]
  },
  "en": {
   "scope": [
    "Set of spikes (2 pieces)",
    "Plastic spacers",
    "Machine screws for fitting"
   ],
   "tools": [
    "Flat-blade screwdriver",
    "Screwdriver for the machine screws"
   ],
   "safety": [
    "Ease the wheel cap off carefully so the clips do not break.",
    "Without the plastic spacers the spikes will not seat correctly.",
    "Tighten the screws by hand and not too firmly."
   ],
   "steps": [
    {
     "t": "Prepare the mower",
     "d": "Switch off, cut the power and rest the mower on a soft surface."
    },
    {
     "t": "Remove the wheel cap",
     "d": "Carefully lever the wheel cap off with a flat-blade screwdriver."
    },
    {
     "t": "Insert the spacers",
     "d": "Place the plastic spacers in the positions provided."
    },
    {
     "t": "Position the spikes",
     "d": "Lay the spike set on and line the holes up with the spacers."
    },
    {
     "t": "Screw on",
     "d": "Fit the machine screws supplied, by hand. Do not overtighten."
    },
    {
     "t": "Check the fit",
     "d": "Check that everything sits evenly and the wheel turns freely."
    }
   ]
  }
 }
};

/* Produkte aus deiner Artikelliste.
   amazon = Link zum Amazon-Listing, pdf = Link zur PDF, video = Link zum Video (YouTube oder MP4).
   Leeres Feld heisst: der Knopf bzw. das Video erscheint nicht.
   id NIE aendern - sie steht im QR-Code. */
const PRODUCTS = [
 {
  "id": "sp-bosch",
  "sku": "SP-BOSCH",
  "cat": "SP",
  "ean": "4260715190120",
  "brand": "Bosch",
  "variant": "SP-AUSSEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Bosch Indego",
   "fits": "Bosch Indego"
  },
  "en": {
   "name": "Spikes for Bosch Indego",
   "fits": "Bosch Indego"
  }
 },
 {
  "id": "sp-dreame",
  "sku": "SP-DREAME-SI · SP-DREAME-SW",
  "cat": "SP",
  "ean": "4260715190816 · 4260715190847",
  "brand": "Dreame",
  "variant": "SP-INNEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Dreame (Silber, Schwarz)",
   "fits": "Dreame"
  },
  "en": {
   "name": "Spikes for Dreame (silver, black)",
   "fits": "Dreame"
  }
 },
 {
  "id": "sp-ecovacs",
  "sku": "SP-ECOVACS-SI · SP-ECOVACS-SW",
  "cat": "SP",
  "ean": "4260715190663 · 4260715190731",
  "brand": "Ecovacs",
  "variant": "SP-AUSSEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Ecovacs (Silber, Schwarz)",
   "fits": "Ecovacs"
  },
  "en": {
   "name": "Spikes for Ecovacs (silver, black)",
   "fits": "Ecovacs"
  }
 },
 {
  "id": "sp-eufy",
  "sku": "SP-EUFY",
  "cat": "SP",
  "ean": "4260715190465",
  "brand": "Eufy",
  "variant": "SP-INNEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Eufy",
   "fits": "Eufy"
  },
  "en": {
   "name": "Spikes for Eufy",
   "fits": "Eufy"
  }
 },
 {
  "id": "sp-husq310",
  "sku": "SP-HUSQ310",
  "cat": "SP",
  "ean": "4260715190236",
  "brand": "Husqvarna",
  "variant": "SP-AUSSEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Husqvarna 310 (Edelstahl)",
   "fits": "Husqvarna 310"
  },
  "en": {
   "name": "Spikes for Husqvarna 310 (stainless steel)",
   "fits": "Husqvarna 310"
  }
 },
 {
  "id": "sp-husq420",
  "sku": "SP-HUSQ420",
  "cat": "SP",
  "ean": "4260715190229",
  "brand": "Husqvarna",
  "variant": "SP-AUSSEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Husqvarna 420 (Edelstahl)",
   "fits": "Husqvarna 420"
  },
  "en": {
   "name": "Spikes for Husqvarna 420 (stainless steel)",
   "fits": "Husqvarna 420"
  }
 },
 {
  "id": "sp-mova600",
  "sku": "SP-MOVA600",
  "cat": "SP",
  "ean": "4260715190977",
  "brand": "Mova",
  "variant": "SP-INNEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Mova 600",
   "fits": "Mova 600"
  },
  "en": {
   "name": "Spikes for Mova 600",
   "fits": "Mova 600"
  }
 },
 {
  "id": "sp-movalid",
  "sku": "SP-MOVALID",
  "cat": "SP",
  "ean": "4260715190960",
  "brand": "Mova",
  "variant": "SP-AUSSEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Mova LiDAX Ultra",
   "fits": "Mova LiDAX Ultra"
  },
  "en": {
   "name": "Spikes for Mova LiDAX Ultra",
   "fits": "Mova LiDAX Ultra"
  }
 },
 {
  "id": "sp-navimow",
  "sku": "SP-NAVIMOW-SI · SP-NAVIMOW-SW",
  "cat": "SP",
  "ean": "4260715190564 · 4260715190588",
  "brand": "Segway Navimow",
  "variant": "SP-AUSSEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Segway Navimow (Silber, Schwarz)",
   "fits": "Segway Navimow"
  },
  "en": {
   "name": "Spikes for Segway Navimow (silver, black)",
   "fits": "Segway Navimow"
  }
 },
 {
  "id": "sp-navimowlid",
  "sku": "SP-NAVIMOWLID-SI · SP-NAVIMOWLID-SW",
  "cat": "SP",
  "ean": "4260715190908 · 4260715190915",
  "brand": "Segway Navimow",
  "variant": "SP-KAPPE",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Segway Navimow LiDAR (Silber, Schwarz)",
   "fits": "Segway Navimow LiDAR"
  },
  "en": {
   "name": "Spikes for Segway Navimow LiDAR (silver, black)",
   "fits": "Segway Navimow LiDAR"
  }
 },
 {
  "id": "sp-navimowx420",
  "sku": "SP-NAVIMOWX420",
  "cat": "SP",
  "ean": "4260715190953",
  "brand": "Segway Navimow",
  "variant": "SP-AUSSEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Segway Navimow X420",
   "fits": "Segway Navimow X420"
  },
  "en": {
   "name": "Spikes for Segway Navimow X420",
   "fits": "Segway Navimow X420"
  }
 },
 {
  "id": "sp-worxl",
  "sku": "SP-WORXL-SI · SP-WORXL-SW",
  "cat": "SP",
  "ean": "4260715190083 · 4260715190533",
  "brand": "Worx",
  "variant": "SP-AUSSEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Worx Landroid L (Silber, Schwarz)",
   "fits": "Worx Landroid L"
  },
  "en": {
   "name": "Spikes for Worx Landroid L (silver, black)",
   "fits": "Worx Landroid L"
  }
 },
 {
  "id": "sp-worxpl",
  "sku": "SP-WORXPL-SI · SP-WORXPL-SW",
  "cat": "SP",
  "ean": "4260715190304 · 4260715190540",
  "brand": "Worx",
  "variant": "SP-AUSSEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Worx Landroid Plus (Silber, Schwarz)",
   "fits": "Worx Landroid Plus"
  },
  "en": {
   "name": "Spikes for Worx Landroid Plus (silver, black)",
   "fits": "Worx Landroid Plus"
  }
 },
 {
  "id": "sp-yf400",
  "sku": "SP-YF400-SI · SP-YF400-SW",
  "cat": "SP",
  "ean": "4260715190137 · 4260715190724",
  "brand": "Yardforce",
  "variant": "SP-AUSSEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Yardforce 400 (Silber, Schwarz)",
   "fits": "Yardforce 400",
   "hinweis": "Je nach Yardforce-Modell werden die Spikes innen oder außen am Rad montiert. Prüfe vor dem Anzeichnen, welche Seite bei deinem Gerät passt."
  },
  "en": {
   "name": "Spikes for Yardforce 400 (silver, black)",
   "fits": "Yardforce 400",
   "hinweis": "Depending on the Yardforce model, the spikes go on the inside or the outside of the wheel. Check which side fits your unit before marking the holes."
  }
 },
 {
  "id": "sp-yf500",
  "sku": "SP-YF500",
  "cat": "SP",
  "ean": "4260715190045",
  "brand": "Yardforce",
  "variant": "SP-AUSSEN",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Yardforce 500",
   "fits": "Yardforce 500",
   "hinweis": "Je nach Yardforce-Modell werden die Spikes innen oder außen am Rad montiert. Prüfe vor dem Anzeichnen, welche Seite bei deinem Gerät passt."
  },
  "en": {
   "name": "Spikes for Yardforce 500",
   "fits": "Yardforce 500",
   "hinweis": "Depending on the Yardforce model, the spikes go on the inside or the outside of the wheel. Check which side fits your unit before marking the holes."
  }
 },
 {
  "id": "sp-yuka",
  "sku": "SP-YUKA-SI · SP-YUKA-SW",
  "cat": "SP",
  "ean": "4260715190687 · 4260715190755",
  "brand": "Mammotion",
  "variant": "SP-KAPPE",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Mammotion Yuka (Silber, Schwarz)",
   "fits": "Mammotion Yuka"
  },
  "en": {
   "name": "Spikes for Mammotion Yuka (silver, black)",
   "fits": "Mammotion Yuka"
  }
 },
 {
  "id": "sp-yukamini",
  "sku": "SP-YUKAMINI-SI · SP-YUKAMINI-SW",
  "cat": "SP",
  "ean": "4260715190670 · 4260715190748",
  "brand": "Mammotion",
  "variant": "SP-KAPPE",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Mammotion Yuka Mini (Silber, Schwarz)",
   "fits": "Mammotion Yuka Mini"
  },
  "en": {
   "name": "Spikes for Mammotion Yuka Mini (silver, black)",
   "fits": "Mammotion Yuka Mini"
  }
 },
 {
  "id": "sp-luba",
  "sku": "SP-LUBA",
  "cat": "SP",
  "ean": "4260715190922",
  "brand": "Mammotion",
  "variant": "SP-SENKKOPF",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Mammotion Luba",
   "fits": "Mammotion Luba"
  },
  "en": {
   "name": "Spikes for Mammotion Luba",
   "fits": "Mammotion Luba"
  }
 },
 {
  "id": "sp-lubam1",
  "sku": "SP-LUBAM1",
  "cat": "SP",
  "ean": "4260715190939",
  "brand": "Mammotion",
  "variant": "SP-SENKKOPF",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Mammotion Luba Mini 1",
   "fits": "Mammotion Luba Mini 1"
  },
  "en": {
   "name": "Spikes for Mammotion Luba Mini 1",
   "fits": "Mammotion Luba Mini 1"
  }
 },
 {
  "id": "sp-lubam2",
  "sku": "SP-LUBAM2",
  "cat": "SP",
  "ean": "4260715190946",
  "brand": "Mammotion",
  "variant": "SP-SENKKOPF",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Spikes für Mammotion Luba Mini 2",
   "fits": "Mammotion Luba Mini 2"
  },
  "en": {
   "name": "Spikes for Mammotion Luba Mini 2",
   "fits": "Mammotion Luba Mini 2"
  }
 },
 {
  "id": "kl-gardena",
  "sku": "KL-GARDENA-18 · KL-GARDENA-33",
  "cat": "KL",
  "ean": "4260715190595 · 4260715190601",
  "brand": "Gardena",
  "variant": "KL-GARDENA",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Klingen für Gardena (18 oder 33 Stück)",
   "fits": "Gardena"
  },
  "en": {
   "name": "Blades for Gardena (18 oder 33 pieces)",
   "fits": "Gardena"
  }
 },
 {
  "id": "kl-mamotion",
  "sku": "KL-MAMOTION-18 · KL-MAMOTION-33",
  "cat": "KL",
  "ean": "4260715190694 · 4260715190700",
  "brand": "Mammotion",
  "variant": "KL-MAMOTION",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Klingen für Mammotion (18 oder 33 Stück)",
   "fits": "Mammotion"
  },
  "en": {
   "name": "Blades for Mammotion (18 oder 33 pieces)",
   "fits": "Mammotion"
  }
 },
 {
  "id": "kl-worx",
  "sku": "KL-WORX-18 · KL-WORX-33",
  "cat": "KL",
  "ean": "4260715190618 · 4260715190625",
  "brand": "Worx",
  "variant": "KL-WORX",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Klingen für Worx Landroid (18 oder 33 Stück)",
   "fits": "Worx Landroid"
  },
  "en": {
   "name": "Blades for Worx Landroid (18 oder 33 pieces)",
   "fits": "Worx Landroid"
  }
 },
 {
  "id": "mt-navimow",
  "sku": "MT-NAVIMOW",
  "cat": "MT",
  "ean": "4260715190632",
  "brand": "Segway Navimow",
  "variant": "MT-NAVIMOW",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Messerteller für Segway Navimow",
   "fits": "Segway Navimow"
  },
  "en": {
   "name": "Blade disc for Segway Navimow",
   "fits": "Segway Navimow"
  }
 },
 {
  "id": "mt-worxl",
  "sku": "MT-WORXL",
  "cat": "MT",
  "ean": "4260715190656",
  "brand": "Worx",
  "variant": "MT-WORXL",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Messerteller für Worx Landroid L",
   "fits": "Worx Landroid L"
  },
  "en": {
   "name": "Blade disc for Worx Landroid L",
   "fits": "Worx Landroid L"
  }
 },
 {
  "id": "mt-worxsm",
  "sku": "MT-WORXSM",
  "cat": "MT",
  "ean": "4260715190649",
  "brand": "Worx",
  "variant": "MT-WORXSM",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Messerteller für Worx Landroid S/M",
   "fits": "Worx Landroid S/M"
  },
  "en": {
   "name": "Blade disc for Worx Landroid S/M",
   "fits": "Worx Landroid S/M"
  }
 },
 {
  "id": "mt-yukamini",
  "sku": "MT-YUKAMINI",
  "cat": "MT",
  "ean": "4260715190854",
  "brand": "Mammotion",
  "variant": "MT-YUKAMINI",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Messerteller für Mammotion Yuka Mini",
   "fits": "Mammotion Yuka Mini"
  },
  "en": {
   "name": "Blade disc for Mammotion Yuka Mini",
   "fits": "Mammotion Yuka Mini"
  }
 },
 {
  "id": "rs-xl",
  "sku": "RS-XL",
  "cat": "RS",
  "ean": "4260715190526",
  "brand": "Universal",
  "variant": "RS-XL",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Radschutz XL",
   "fits": "Universal"
  },
  "en": {
   "name": "Wheel guard XL",
   "fits": "Universal"
  }
 },
 {
  "id": "rs-xl-2",
  "sku": "RS-XL-2",
  "cat": "RS",
  "ean": "4260715190762",
  "brand": "Universal",
  "variant": "RS-XL",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Radschutz XL (2er-Set)",
   "fits": "Universal",
   "scope": [
    "2 Radschutz"
   ]
  },
  "en": {
   "name": "Wheel guard XL (pack of 2)",
   "fits": "Universal",
   "scope": [
    "2 wheel guards"
   ]
  }
 },
 {
  "id": "ks-yukamini",
  "sku": "KS-YUKAMINI-SW · KS-YUKAMINI-WS",
  "cat": "KS",
  "ean": "4260715190793 · 4260715190809",
  "brand": "Mammotion",
  "variant": "KS-YUKAMINI",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Kantenschutz für Mammotion Yuka Mini (Schwarz, Weiß)",
   "fits": "Mammotion Yuka Mini"
  },
  "en": {
   "name": "Edge protection for Mammotion Yuka Mini (black, white)",
   "fits": "Mammotion Yuka Mini"
  }
 },
 {
  "id": "wh-navimow",
  "sku": "WH-NAVIMOW",
  "cat": "WH",
  "ean": "4260715190823",
  "brand": "Segway Navimow",
  "variant": "WH-NAVIMOW",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Wandhalterung für Segway Navimow",
   "fits": "Segway Navimow"
  },
  "en": {
   "name": "Wall mount for Segway Navimow",
   "fits": "Segway Navimow"
  }
 },
 {
  "id": "wh-navimow-set",
  "sku": "WH-NAVIMOW-SET",
  "cat": "WH",
  "ean": "4260715190830",
  "brand": "Segway Navimow",
  "variant": "WH-NAVIMOW",
  "amazon": "",
  "pdf": "",
  "video": "",
  "de": {
   "name": "Wandhalterung für Segway Navimow inkl. Klingen",
   "fits": "Segway Navimow",
   "scope": [
    "Wandhalterungen",
    "Schrauben und Dübel",
    "Klingen-Satz",
    "Papierschablone zum Ausdrucken"
   ]
  },
  "en": {
   "name": "Wall mount for Segway Navimow incl. blades",
   "fits": "Segway Navimow",
   "scope": [
    "Wall brackets",
    "Screws and wall plugs",
    "Set of blades",
    "Paper template for printing"
   ]
  }
 }
];

const QR = {"de": "<div class=\"qr\"><section><img src=\"__IMGBASE__qr-kontakt.png\" alt=\"QR-Code Kontakt\"><div><h4>Frage zum Produkt?</h4><p>Schreib uns, wir antworten werktags innerhalb eines Tages.</p><p class=\"mailrow\"><a class=\"mail\" href=\"mailto:support@nf-brothers.de\">support@nf-brothers.de</a></p></div></section><section><img src=\"__IMGBASE__qr-bewertung.png\" alt=\"QR-Code Bewertung\"><div><h4>Bewertung abgeben</h4><p>Wir sind ein kleines Unternehmen. Eine kurze Bewertung hilft uns enorm und anderen bei der Auswahl.</p></div></section></div>", "en": "<div class=\"qr\"><section><img src=\"__IMGBASE__qr-kontakt.png\" alt=\"QR-Code Kontakt\"><div><h4>Question about the product?</h4><p>Write to us, we reply within one working day.</p><p class=\"mailrow\"><a class=\"mail\" href=\"mailto:support@nf-brothers.de\">support@nf-brothers.de</a></p></div></section><section><img src=\"__IMGBASE__qr-bewertung.png\" alt=\"QR-Code Bewertung\"><div><h4>Leave a review</h4><p>We are a small business. A short review helps us enormously and helps other buyers decide.</p></div></section></div>"};

/* ====== HIER EINTRAGEN ======
   Adresse des Ordners, in dem die PDFs liegen, mit Schraegstrich am Ende.
   Beispiel: "https://cdn.shopify.com/s/files/1/1234/5678/files/"
   Leer lassen heisst: kein PDF-Knopf.
   Die Datei je Artikel heisst wie die id, also z.B. sp-luba.pdf              */
const PDF_BASE = "https://cdn.shopify.com/s/files/1/0860/3025/4400/files/";

/* Ordner mit logo.png, qr-kontakt.png und qr-bewertung.png. Meist derselbe wie oben. */
const IMG_BASE = PDF_BASE;

/* Datei mit der Bohrschablone, liegt im selben Ordner wie die PDFs. */
const SCHABLONE = "schablone-wandhalterung.pdf";

let lang = (navigator.language || "de").toLowerCase().startsWith("de") ? "de" : "en";
let cat = null, brand = null;
const esc = s => String(s == null ? "" : s).replace(/[&<>"]/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));

const brandsIn = c => [...new Set(PRODUCTS.filter(p => p.cat === c).map(p => p.brand))].sort();
const pool = () => PRODUCTS.filter(p => (!cat || p.cat === cat) && (!brand || p.brand === brand));

function applyStatic(){
  const t = UI[lang];
  document.documentElement.lang = lang;
  root.querySelectorAll("[data-t]").forEach(el => {
    const v = t[el.dataset.t];
    if (typeof v === "string") el.textContent = v;
  });
  $("#q").placeholder = t.search;
  $("#q").setAttribute("aria-label", t.search);
  root.querySelectorAll(".langs button").forEach(b =>
    b.setAttribute("aria-pressed", String(b.dataset.lang === lang)));
}

function itemRow(kind, key, label, sub, count, icon){
  return `<li><button type="button" class="row" data-${kind}="${esc(key)}">
      <span><h2>${esc(label)}</h2>${sub ? `<p>${esc(sub)}</p>` : ""}</span>
      ${count != null ? `<span class="cnt">${esc(count)}</span>` : ""}
      <svg class="arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="m9 5 7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button></li>`;
}

function renderCrumbs(mode){
  const t = UI[lang];
  $("#crumbs").innerHTML = mode === "cat" ? "" :
    `<button type="button" data-reset="1">← ${esc(t.back)}</button>`;
}

function render(){
  const t = UI[lang];
  const q = $("#q").value.trim().toLowerCase();
  let mode, rows, n = null;

  if (q){
    mode = "search";
    const hits = PRODUCTS.filter(p => {
      const hay = [p[lang].name, p[lang].fits, p.sku, p.ean, p.brand, CATS[p.cat][lang]].join(" ").toLowerCase();
      return q.split(/\s+/).every(w => hay.includes(w));
    });
    rows = hits.map(p => itemRow("id", p.id, p[lang].name, p.sku, null, p.cat));
    n = t.count(hits.length);
  } else if (!cat){
    mode = "cat";
    rows = [...new Set(PRODUCTS.map(p => p.cat))].map(c =>
      itemRow("cat", c, CATS[c][lang], null, null, c));
  } else if (!brand && brandsIn(cat).length > 1){
    mode = "brand";
    rows = brandsIn(cat).map(b => {
      const ps = PRODUCTS.filter(p => p.cat === cat && p.brand === b);
      return ps.length === 1
        ? itemRow("id", ps[0].id, b, ps[0][lang].name, null, cat)
        : itemRow("brand", b, b, null, null, cat);
    });
  } else {
    mode = "product";
    const hits = pool();
    rows = hits.map(p => itemRow("id", p.id, p[lang].name, p.sku, null, p.cat));
    n = t.count(hits.length);
  }

  $("#title").textContent = t.title[mode];
  $("#lede").textContent  = t.lede[mode];
  $("#count").textContent = n || "";
  $("#count").classList.toggle("hide", !n);
  $("#empty").classList.toggle("hide", rows.length > 0);
  $("#list").innerHTML = rows.join("");
  $("#thanks").textContent = THANKS[lang];
  $("#thanks").classList.toggle("hide", mode !== "cat");
  renderCrumbs(mode);
}

function videoHtml(p){
  const url = p.video;
  if (!url) return "";
  const yt = url.match(/(?:youtu\.be\/|v=|shorts\/|embed\/)([\w-]{6,})/);
  const inner = yt
    ? `<iframe src="https://www.youtube-nocookie.com/embed/${yt[1]}" title="Video" allowfullscreen loading="lazy"></iframe>`
    : `<video src="${esc(url)}" controls preload="metadata"></video>`;
  return `<h3 class="sec">${esc(UI[lang].video)}</h3><div class="videobox">${inner}</div>`;
}

function renderDoc(p){
  const t = UI[lang];
  // Ebene 3 schlaegt Ebene 2 schlaegt Ebene 1: Produkt > Montagevariante > Kategorie
  const v = VARIANTS[p.variant] ? (VARIANTS[p.variant][lang] || {}) : {};
  const c = CATDEF[p.cat][lang] || {};
  const f = k => (p[lang] && p[lang][k]) || v[k] || c[k] || [];

  const list  = (h, arr) => arr.length ? `<h3 class="sec">${esc(h)}</h3><ul class="plain">${arr.map(x => `<li>${esc(x)}</li>`).join("")}</ul>` : "";
  const chips = (h, arr) => arr.length ? `<h3 class="sec">${esc(h)}</h3><ul class="tools">${arr.map(x => `<li>${esc(x)}</li>`).join("")}</ul>` : "";
  const safety = f("safety"), steps = f("steps");

  const buy = [];
  if (p.amazon) buy.push(`<a class="btn primary" href="${esc(p.amazon)}" target="_blank" rel="noopener">${esc(t.amazon)}</a>`);
  const pdfUrl = p.pdf || (PDF_BASE ? PDF_BASE + p.id + ".pdf" : "");
  if (pdfUrl)   buy.push(`<a class="btn ghost" href="${esc(pdfUrl)}" target="_blank" rel="noopener">${esc(t.pdf)}</a>`);
  if (p.cat === "WH" && PDF_BASE)
    buy.push(`<a class="btn ghost" href="${esc(PDF_BASE + SCHABLONE)}" target="_blank" rel="noopener">${esc(t.schablone)}</a>`);

  $("#doc").innerHTML = `
    <button type="button" class="back" id="backBtn">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="m15 5-7 7 7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>${esc(t.back)}
    </button>
    <h1>${esc(p[lang].name)}</h1>
    <p class="meta">${esc(t.fits)} <b>${esc(p[lang].fits)}</b><br>${esc(p.sku)}${p.ean ? " · EAN " + esc(p.ean) : ""}</p>

    ${safety.length ? `<div class="notice"><h3>${esc(t.safety)}</h3>
      <ul>${safety.map(s => `<li>${esc(s)}</li>`).join("")}</ul></div>` : ""}

    <details class="general">
      <summary>${esc(t.general)}</summary>
      <ul>${GENERAL[lang].map(s => `<li>${esc(s)}</li>`).join("")}</ul>
    </details>

    ${list(t.scope, f("scope"))}
    ${chips(t.tools, f("tools"))}

    <h3 class="sec">${esc(t.steps)}</h3>
    <ol class="steps">${steps.map(s => `<li><strong>${esc(s.t)}</strong><p>${esc(s.d)}</p></li>`).join("")}</ol>
    ${p[lang].hinweis ? `<p class="hinweis">${esc(p[lang].hinweis)}</p>` : ""}

    ${list(t.after, f("after"))}
    ${list(t.care, f("care"))}

    ${videoHtml(p)}
    ${buy.length ? `<div class="buy" style="margin:22px 0 0">${buy.join("")}</div>` : ""}
    <p class="note">${esc(NOTE[lang])}</p>
    ${QR[lang].split("__IMGBASE__").join(IMG_BASE)}`;
  $("#backBtn").addEventListener("click", () => { cat = null; brand = null; $("#q").value = ""; location.hash = ""; });
}

function route(){
  const id = decodeURIComponent(location.hash.replace(/^#\/?/, "")).toLowerCase();
  const p = PRODUCTS.find(x => x.id === id);
  $("#finder").classList.toggle("hide", !!p);
  $("#doc").classList.toggle("hide", !p);
  if (p){
    if (!$("#q").value.trim()){ cat = p.cat; brand = brandsIn(p.cat).length > 1 ? p.brand : null; }
    renderDoc(p);
    root.querySelector("[data-t='brand']").textContent = UI[lang].brandOne;
    document.title = p[lang].name + " · " + UI[lang].brand;
  } else {
    render();
    root.querySelector("[data-t='brand']").textContent = UI[lang].brand;
    document.title = UI[lang].brand;
  }
  window.scrollTo(0, 0);
}

root.addEventListener("click", e => {
  const langBtn = e.target.closest(".langs button");
  if (langBtn){ lang = langBtn.dataset.lang; applyStatic(); route(); return; }

  const el = e.target.closest("[data-reset],[data-cat],[data-brand],[data-id],[data-home]");
  if (!el) return;
  if (el.dataset.home !== undefined) e.preventDefault();

  if (el.dataset.id !== undefined){ location.hash = "/" + el.dataset.id; return; }
  if (el.dataset.brand !== undefined){ brand = el.dataset.brand; render(); return; }
  if (el.dataset.cat !== undefined){ cat = el.dataset.cat; brand = null; render(); return; }
  cat = null; brand = null; $("#q").value = "";
  if (el.dataset.home !== undefined && location.hash) location.hash = "";
  else render();
});

$("#q").addEventListener("input", render);
window.addEventListener("hashchange", route);
(function(){ const lg = root.querySelector(".logo"); if (lg) lg.src = IMG_BASE + "logo.png"; })();
applyStatic();
route();

})();